var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarDrawerNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_334_5695)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.80664,
    y: 6.93848,
    width: 23,
    height: 23,
    rx: 6.11964,
    fill: "#373843"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.21735,
    y: 7.34919,
    width: 22.1786,
    height: 22.1786,
    rx: 5.70893,
    stroke: "#3E3E4E",
    strokeWidth: 0.821429
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_5695)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9716 15.2962C20.138 15.4626 20.138 15.7324 19.9716 15.8989L17.3183 18.5521L19.9716 21.2054C20.138 21.3718 20.138 21.6416 19.9716 21.808C19.8052 21.9744 19.5354 21.9744 19.369 21.808L16.4144 18.8534C16.2479 18.687 16.2479 18.4172 16.4144 18.2508L19.369 15.2962C19.5354 15.1298 19.8052 15.1298 19.9716 15.2962Z",
    fill: "#EDEDF1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_334_5695",
    x: 0.806641,
    y: 0.938477,
    width: 35,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_334_5695"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_334_5695"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_334_5695",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_5695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.0002,
    height: 15.0002,
    fill: "white",
    transform: "translate(10.8066 10.9385)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarDrawerNewIcon);
export default __webpack_public_path__ + "static/media/sidebar-drawer-new-icon.e08417a435035c09e6947ea705fac501.svg";
export { ForwardRef as ReactComponent };